import Contracts from './Index.vue';

export const routes = [
  {
    path: 'contratos',
    name: 'talkvia_contracts',
    meta: {
      permissions: ['administrator'],
      superAdminOrAdmin: true,
    },
    component: Contracts,
  },
];
